import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { graphqlEndpoints } from '@/utils/config';

// Install the vue plugin
Vue.use(VueApollo);

// Http endpoint
const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:4000/graphql';
// Files URL root
export const filesRoot = process.env.VUE_APP_FILES_ROOT || httpEndpoint.substr(0, httpEndpoint.indexOf('/graphql'));

Vue.prototype.$filesRoot = filesRoot;

const createLink = (endpoint: 'create' | 'update' | 'default'): ApolloLink => {
  const urlMap = {
    create: {
      uri: new URL(graphqlEndpoints.createProvider, window.location.origin).toString(),
      fetchOptions: {},
    },
    update: {
      uri: new URL(graphqlEndpoints.updateProvider, window.location.origin).toString(),
      fetchOptions: {},
    },
    default: {
      uri: new URL(graphqlEndpoints.listings, window.location.origin).toString(),
      fetchOptions: {},
    },
  };

  const link = createHttpLink(urlMap[endpoint] || urlMap.default);
  return link;
};

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('authToken');
  return {
    headers: {
      ...headers,
      authorization: token ? `${token}` : '',
    },
  };
});

const cache = new InMemoryCache();

export const createProviderClient = new ApolloClient({
  link: authLink.concat(createLink('create')),
  cache,
});

export const updateProviderClient = new ApolloClient({
  link: authLink.concat(createLink('update')),
  cache,
});

export const defaultApolloClient = new ApolloClient({
  link: authLink.concat(createLink('default')),
  cache,
});

// Call this in the Vue app file
export function createProvider() {
  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    clients: {
      createProvider: createProviderClient,
      updateProvider: updateProviderClient,
      default: defaultApolloClient,
    },
    defaultClient: defaultApolloClient,
    defaultOptions: {
      $query: {
        // fetchPolicy: 'cache-and-network',
      },
    },
    errorHandler(error) {
      // eslint-disable-next-line no-console
      console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message);
    },
  });

  return apolloProvider;
}
